import React, { Fragment } from "react";
import { SmallTransparentBlogCard } from "@ui/BlogCards";
import type { DeepNonNullable } from "ts-essentials";

const RecommendedArticles = ({
  latestPosts,
  title,
  blogSlug,
}: {
  latestPosts: DeepNonNullable<
    Queries.SpecificPostDataQuery["latestBlogPosts"]["edges"]
  >;
  title: string;
  blogSlug: string;
}) => {
  /**
   * Hacky Query
   * Getting 4 Blogposts
   * And returning latest 3
   * everytime.
   *
   * If post id exists, it discards it
   * so eventually we have again 3 posts
   */

  const posts = latestPosts.slice(0, 3);

  return (
    <div>
      <h2 className="mb-4 text-center font-sans sm:text-left">{title}</h2>
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        {posts.map(post => {
          const { title, publish_at, FeaturedImage, slug, locale, id } =
            post.node;
          return (
            <Fragment key={id}>
              {post && (
                <SmallTransparentBlogCard
                  key={`${slug}${publish_at}`}
                  date={new Date(publish_at)}
                  locale={locale}
                  image={
                    FeaturedImage.localFile.childImageSharp.gatsbyImageData
                  }
                  postURL={slug}
                  title={title}
                  blogSlug={blogSlug}
                />
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default RecommendedArticles;
